export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  REVIEW: {
    Title: 'Pending Review',
    Color: '#DDE7FF',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
